import React from "react";
import { Quote } from "lucide-react";
import { useT } from "@/lib/i18n";

const TESTIMONIALS = [
  {
    quote:
      "Zopran moved our Hannover Messe shipment through German customs without a single hold. The ATA Carnet and on-site handling was flawless.",
    name: "Operations Director",
    role: "Indian Industrial OEM",
  },
  {
    quote:
      "DDP into Germany used to be a black box. Zopran gave us a single landed cost per SKU and delivered into Amazon DE FCs on time, every time.",
    name: "Head of Supply Chain",
    role: "Cross-border D2C Brand",
  },
  {
    quote:
      "Their German team handled an AOG aircraft-spares move from MAA to FRA tarmac-side within hours — fully white-glove. Class-leading.",
    name: "MRO Operations Manager",
    role: "Aerospace Maintenance · UAE",
  },
];

const LOGOS = [
  "AEROSHIP", "SHIPMYPARCELS", "ZOPRAN GMBH", "FRA HUB", "EU CUSTOMS",
  "AMAZON FBA", "ATA CARNET", "AEROSPACE WG", "AUTOMOTIVE WG", "BONDED WMS",
];

export default function Testimonials() {
  const { t } = useT();
  return (
    <section data-testid="testimonials-section" className="relative py-24 sm:py-28 zp-band-soft border-y border-[color:var(--zp-border)] overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="max-w-2xl mb-14">
          <div className="zp-label">{t("test.eyebrow")}</div>
          <h2 className="font-display text-3xl sm:text-5xl tracking-tighter mt-3">
            {t("test.title")}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {TESTIMONIALS.map((tm, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className="zp-card p-7 relative"
            >
              <Quote size={26} className="text-[color:var(--zp-cyan-2)]" />
              <blockquote className="text-[color:var(--zp-navy)] mt-4 leading-relaxed">
                {tm.quote}
              </blockquote>
              <figcaption className="mt-6">
                <div className="font-display tracking-tight text-[color:var(--zp-navy)]">{tm.name}</div>
                <div className="text-xs text-[color:var(--zp-text-3)] mt-1">{tm.role}</div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>

      <div className="mt-16 relative">
        <div className="absolute inset-y-0 left-0 w-20 bg-gradient-to-r from-[#F1FAFB] to-transparent z-10" />
        <div className="absolute inset-y-0 right-0 w-20 bg-gradient-to-l from-[#F1FAFB] to-transparent z-10" />
        <div className="overflow-hidden">
          <div className="zp-marquee">
            {[...LOGOS, ...LOGOS].map((l, i) => (
              <div key={i} className="font-display tracking-[0.2em] text-[color:var(--zp-text-3)] text-sm whitespace-nowrap font-semibold">
                {l}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
